import React from 'react';
import './WhatsAppButton.css'; // Import the CSS for styling

const WhatsAppButton = () => {
  const whatsappNumber = "919990168777"; // Replace with your number
  const message = "Hello! I'm interested in your services.";
  const imageUrl = "/whatsaapicon.png"; // Replace with your desired image URL

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <img src={imageUrl} alt="WhatsApp" className="whatsapp-img" />
    </a>
  );
};

export default WhatsAppButton;
